import { useState } from "react";
import useCurrentUser from "../../../../hooks/useCurrentUser";

export default (popupData) => {
  const { data: currentUser } = useCurrentUser();
  const [members, setMembers] = useState(popupData?.selectedMembers);

  const onMemberChange = (val, command) => {
    const cancelCriteria =
      val?.reference === currentUser?.reference ||
      val === currentUser?.reference;

    if (cancelCriteria) return;

    switch (command) {
      case "add":
        setMembers((prev) => [...prev, val?.reference]);
        popupData?.onAdd(val);
        return;
      default:
        setMembers((prev) => prev?.filter((item) => item !== val));
        popupData?.onRemove(val);
    }
  };

  const usersByKind = popupData?.members?.filter(
    (user) => user.kind === "member"
  );

  return { members, usersByKind, onMemberChange };
};
